import { PATH_BUILDER } from 'constants/actionTypes';
import { configureStore } from './configureStore';
import pathBuilderReducer from '../reducers/pathBuilder';

export default function createStore(initialState) {
  const store = configureStore(initialState, {
    pathBuilder: pathBuilderReducer,
    meta: () => initialState.meta,
    editor: () => initialState.editor,
  });

  // initiating lastRevision on page load when editing an existing path
  if (initialState.pathBuilder.id) {
    store.dispatch({ type: PATH_BUILDER.PATH.SAVE_REVISION });
  }

  return store;
}
